import { TableRow, TableCell, Checkbox } from '@occc-app/design-system';
import { KioskFragment } from '@occc/graphql';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';
import { formatFullAddress } from '@occc/utils-formatters';

type TouchpointKiosksTableItemProps = {
  kiosk: KioskFragment;
  isItemSelected: boolean;
  isItemDisabled?: boolean;
  handleItemSelect: (id: string, kiosk: KioskFragment) => void;
};

const formatPhoneNumbers = (phoneNumbers?: { phoneNumber: string }[] | null): string => {
  if (!phoneNumbers?.length) return '-';

  const firstPhone = phoneNumbers[0]?.phoneNumber;
  if (!firstPhone) return '-';

  try {
    return formatPhoneNumberNationalForUS(firstPhone);
  } catch {
    return firstPhone;
  }
};

export const TouchpointKiosksTableItem = ({
  kiosk,
  isItemSelected,
  isItemDisabled = false,
  handleItemSelect,
}: TouchpointKiosksTableItemProps) => {
  const locationAddress = formatFullAddress(kiosk.location?.address) || '-';
  const kioskName = kiosk.externalDisplayId || '-';
  const phoneNumber = formatPhoneNumbers(kiosk.location?.phoneNumbers);

  return (
    <TableRow key={kiosk.id} selected={isItemSelected}>
      <TableCell padding='checkbox'>
        <Checkbox
          checked={isItemSelected}
          disabled={isItemDisabled}
          onClick={(event) => {
            event.stopPropagation();
            if (!isItemDisabled) {
              handleItemSelect(kiosk.id, kiosk);
            }
          }}
        />
      </TableCell>
      <TableCell>{kiosk.id}</TableCell>
      <TableCell>{kioskName}</TableCell>
      <TableCell>{locationAddress}</TableCell>
      <TableCell>{phoneNumber}</TableCell>
    </TableRow>
  );
};
